module.exports = __webpack_public_path__ + "img/stepvan_driving.c7ca5e80.svg";